import { createPermission } from '@backstage/plugin-permission-common';

export const catalogHealthReadPermission = createPermission({
  name: 'catalog-health.read',
  attributes: { action: 'read' },
});
